define('home/views/FollowingCardView',[
    'backbone-marionette',

    'home/mixins/withChannelAvatar',
    'home/templates/followingCard',
], function (
    Marionette,

    withChannelAvatar,
    followingCardTemplate
) {
    'use strict';

    var FollowingCardView = Marionette.ItemView.extend({
        template: followingCardTemplate,
        className: 'aside-list__item',
    });

    withChannelAvatar.call(FollowingCardView.prototype, function () {
        return this.model.channel;
    });

    return FollowingCardView;
});

